import { getLastFriendlyFrameElement, isAmpPage } from './dom';
import { isInIframe } from './iframe';

const SAFEFRAME_REGEX = /googlesyndication\.com\/safeframe\//;
const SAFEFRAME_DOMAIN_REGEX = /^[0-9a-fA-F]+\.safeframe\.googlesyndication\./;
const DOMAIN_REGEX = /^\w*:\/\/([^\/]*)/;
const SUB_DOMAIN = 'www.';

export const getPageUrl = (globalScope: Window = window) => {
  const isAmp = isAmpPage(globalScope);
  const isFriendlyIframe =
    isInIframe(globalScope) && getLastFriendlyFrameElement(globalScope);

  const urlWaterfall = [
    // Check Amp contexts
    () => isAmp && globalScope?.AMP_CONTEXT_DATA?.canonicalUrl,
    () => isAmp && globalScope.sf_?.cfg?._context?.canonicalUrl,
    () => {
      const url =
        (isFriendlyIframe ? globalScope.top : globalScope)?.location.href || '';
      return !SAFEFRAME_REGEX.test(url) && url;
    },
    () => {
      const ancestorOrigins = globalScope.location.ancestorOrigins || [];
      return ancestorOrigins[ancestorOrigins.length - 1];
    },
    // fallback, last ditch to get the page URL
    () => globalScope.document.location.href,
  ]
    .map((func) => {
      // There's a chance that accessing scope could error in different environments
      try {
        return func();
      } catch (e) {
        return false;
      }
    })
    .filter((url): url is string => !!url);

  // get first match
  return urlWaterfall[0];
};

export const getPageDomain = () => {
  const url = getPageUrl();

  const domainMatch = url.match(DOMAIN_REGEX);
  if (!domainMatch) {
    return 'err';
  }

  const domain = domainMatch[1];

  if (SAFEFRAME_DOMAIN_REGEX.test(domain)) {
    return domain.substring(domain.indexOf('.') + 1);
  }

  if (domain.startsWith(SUB_DOMAIN)) {
    return domain.substring(SUB_DOMAIN.length);
  }

  return domain;
};

export const isMraid = (globalScope: Window = window) => {
  const url = getPageUrl();

  return Boolean(
    globalScope.MRAID_ENV ||
      (/webview/.test(globalScope.navigator.userAgent) &&
        /mraid1_mraid2_mraid3/.test(url)),
  );
};

export const isEnsighten = (globalScope: Window = window) =>
  !!(globalScope.ensBootstraps || globalScope.ensClientConfig);

export const isAppnexusAPN = (globalScope: Window = window) =>
  !!globalScope.apntag;

export const canTrackUser = (globalScope: Window = window) => {
  return globalScope.navigator.doNotTrack || '0';
};
